import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { withdrawalListSuccess, withdrawalListFailure } from "../../Action";
import { WITHDRAWAL_LIST } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* withdrawalListRequest(action) {
  try {
    const { per_page, page, date_from, date_to, status,whitelabelId } = action?.payload?.payload || {};
    const query = `per_page=${per_page}&page=${page}&start_date=${date_from}&end_date=${date_to}&status=${status}&whitelabelId=${whitelabelId}`;
    // The merged list returns the platform rows exactly like `/withdrawal`, plus
    // the whitelabel's external (partner app) withdrawals, each tagged `source`.
    // A whitelabel without external withdrawals gets the same list as before.
    // If the merged list fails, fall back to the platform-only list.
    let data;
    try {
      ({ data } = yield API.get(`/withdrawal-with-external?${query}`));
    } catch (mergedError) {
      data = null;
    }
    if (data?.meta?.code !== 200) {
      ({ data } = yield API.get(`/withdrawal?${query}`));
    }

    if (data?.meta?.code === 200) {
      yield put(withdrawalListSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(withdrawalListFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(withdrawalListFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchWithdrawalListAPI() {
  yield takeEvery(WITHDRAWAL_LIST, withdrawalListRequest);
}

export default function* rootSaga() {
  yield all([watchWithdrawalListAPI()]);
}
